import React, { useEffect, FunctionComponent } from "react";
import { connect } from "react-redux";
import StandaloneSuccess, { StandaloneSuccessProps } from "../../components/v3/newsletter-standalone/StandaloneSuccess";
import StandaloneNewsletter, { StandaloneNewsletterProps, StandaloneNewsletterFunctions } from "../../components/v3/newsletter-standalone/StandaloneNewsletter";
import newsletterActions, { SUCCESS_MESSAGE_TYPE } from "../../ducks/newsletter";
import marketingActions from "ducks/marketing";
import { validateEmail } from "common/utils/Validation";
import { ELOQUA_LEAD_SOURCE_VALUES, SCREENS } from "common/constants/Constants";
import { getSourceFromQuery } from "utils/newsletters";
import { browserHistory } from "react-router";
import appPath from "utils/appPath";
import thinkingActions from "ducks/thinking";
import { NEWSLETTER_UPDATE_SOURCE_STANDALONE_PAGE } from "common/constants/v2/Constants";

interface OwnProps {
    location: {
        query: Record<string, string>;
    };
    params: {
        newsletterListId?: string;
    };
}

type MapStateProps = StandaloneNewsletterProps & { success: boolean } & StandaloneSuccessProps;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mapStateToProps(state: Record<string, any>, props: OwnProps): MapStateProps {
    const {
        country,
        user = {},
        newsletter = {},
        thinking,
        config: { bloombergSiteUrl }
    } = state as {
        config: Record<string, string>;
        country?: string;
        user: Record<string, string>;
        newsletter: Record<string, string>;
        thinking?: string;
    };

    const { location, params: { newsletterListId } } = props;

    const email = location.query.email && decodeURIComponent(location.query.email);
    const emailError = validateEmail(email);
    const queryEmail = emailError ? "" : email;

    return {
        country,
        email: user.email || queryEmail,
        success: newsletter.newsletterMessageType === SUCCESS_MESSAGE_TYPE,
        newsletter: (newsletter.newsletter || { list: newsletterListId }) as InternalNewsletter,
        errorMessage: newsletter.error,
        thinking,
        bloombergSiteUrl
    };
}

export function mapDispatchToProps(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dispatch: (action: any) => Promise<void>, ownProps: OwnProps
): StandaloneNewsletterFunctions {
    return {
        fetchNewsletterData(email?: string): Promise<void> {
            const { location: { query: { hash } }, params: { newsletterListId } } = ownProps;

            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return dispatch(newsletterActions.startFetchingSingleNewsletterData(newsletterListId, email, hash))
                .catch(() => browserHistory.push(appPath(SCREENS.NEWSLETTERS)));
        },

        updateSubscriptions(newsletterSubscriptions: Record<string, boolean>, email: string): Promise<void> {
            const source = getSourceFromQuery(ownProps.location) || NEWSLETTER_UPDATE_SOURCE_STANDALONE_PAGE;

            void dispatch(thinkingActions.setThinking());
            void dispatch(marketingActions.sendEmailToEloquaAndCpref(email, ELOQUA_LEAD_SOURCE_VALUES.NEWSLETTER, true));

            return dispatch(
                newsletterActions.startUpdatingNewsletterSubscription(
                    newsletterSubscriptions, email, { source }
                )
            ).catch(() => undefined).then(() => dispatch(thinkingActions.doneThinking()));
        }
    };
}

type ContainerProps = MapStateProps & StandaloneNewsletterFunctions;

const StandaloneNewsletterContainer: FunctionComponent<ContainerProps> = (props) => {
    const {
        email: initialEmail,
        fetchNewsletterData,
        success,
        bloombergSiteUrl
    } = props;

    useEffect(() => {
        fetchNewsletterData(initialEmail);
    }, [initialEmail, fetchNewsletterData]);

    if (success) {
        return <StandaloneSuccess bloombergSiteUrl={ bloombergSiteUrl } />;
    }

    return <StandaloneNewsletter { ...props } />;
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StandaloneNewsletterContainer);
